/**
 * FNV-1a: a short, one-way fingerprint that tells devices apart in telemetry
 * without sending the browser's device id itself.
 *
 * @param {string} value - The value to fingerprint, e.g. a camera deviceId.
 * @returns {string} Eight hex digits.
 */
export function shortFingerprint(value) {
    let hash = 0x811c9dc5;
    for (let i = 0; i < value.length; i++) {
        hash ^= value.charCodeAt(i);
        hash = Math.imul(hash, 0x01000193);
    }
    return (hash >>> 0).toString(16).padStart(8, '0');
}
